import { Logo } from '@/components/ui/logo'

const CHROME_STORE_URL = 'https://chromewebstore.google.com/detail/fnpbcidkcfbbijjnibgfhdablepmmefk'

const COLUMNS: Array<{ title: string; links: Array<{ label: string; href: string; external?: boolean }> }> = [
  {
    title: 'Product',
    links: [
      { label: 'Scoreboar Analyzer', href: '/virality' },
      { label: 'Chrome extension', href: CHROME_STORE_URL, external: true },
      { label: 'Pricing', href: '/#pricing' },
    ],
  },
  {
    title: 'Resources',
    links: [
      { label: 'Blog', href: '/blog/' },
      { label: 'Questions', href: '/#faq' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Privacy', href: '/privacy' },
      { label: 'Terms', href: '/terms' },
    ],
  },
]

/**
 * The site footer: what x11 is in one line, where to go next, and the year,
 * which follows the calendar instead of being typed in once.
 */
export function Footer() {
  const year = new Date().getFullYear()
  return (
    <footer className="border-t border-border bg-muted/30 px-6 pb-8 pt-12">
      <div className="mx-auto max-w-6xl">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-[1.5fr_1fr_1fr_1fr]">
          <div className="sm:col-span-2 lg:col-span-1">
            <Logo variant="header" />
            <p className="mt-3 max-w-[34ch] text-sm text-muted-foreground">
              Grow your X account with quality content. Just talk.
            </p>
            <a
              href="https://x.com/x11_social"
              target="_blank"
              rel="noopener noreferrer"
              className="key key-lite mt-5 inline-flex items-center gap-2 rounded-lg px-3 py-1.5 text-sm font-medium"
            >
              Follow on
              <svg className="h-3.5 w-3.5" viewBox="0 0 24 24" fill="currentColor" aria-label="X">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
              </svg>
            </a>
          </div>

          {COLUMNS.map(column => (
            <nav key={column.title} aria-label={column.title}>
              <h3 className="text-xs font-medium uppercase tracking-wider text-muted-foreground">{column.title}</h3>
              <ul className="mt-3 space-y-2">
                {column.links.map(link => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      {...(link.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                      className="text-sm text-foreground/80 transition-colors hover:text-foreground"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-border pt-6 text-xs text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} x11.social</p>
          <a href="#top" onClick={event => { event.preventDefault(); window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }) }} className="self-start hover:text-foreground sm:self-auto">
            Back to top
          </a>
        </div>
      </div>
    </footer>
  )
}
